(function() { window.GUID_b3aba21a_142e_4623_b0a7_59cc759dd875 = { getGuid: function() { return "b3aba21a-142e-4623-b0a7-59cc759dd875"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class LazyLoadHelper {
            static Activate() {
                if (!LazyLoadHelper.Instance) {
                    LazyLoadHelper.Instance = new LazyLoadHelper();
                }
                LazyLoadHelper.Instance.start();
            }
            start() {
                let me = this;
                me.locateNextLazyLoadTrigger();
                if (me.$currentLazyLoadTrigger.length > 0) {
                    CS.DOM.$win.offon('scroll.lazyload', function () {
                        CS.Lag('scroll.lag', 150, function () {
                            if (me.$currentLazyLoadTrigger.length > 0) {
                                let triggerTop = me.$currentLazyLoadTrigger.offset().top;
                                var scrollTop = CS.DOM.$win.scrollTop() + CS.DOM.$win.height();
                                if (scrollTop > triggerTop) {
                                    me.$currentLazyLoadTrigger.trigger('lazyload');
                                    CS.DOM.$win.off('scroll.lazyload');
                                    me.$currentLazyLoadTrigger = null;
                                }
                            }
                        });
                    });
                }
                CS.DOM.$body.offon('click.lazyload', '.button-lazy-loader-trigger,.lazy-loader-trigger', function () {
                    let $this = $(this);
                    let data = {
                        SkipQuantity: $this.data('skipquantity')
                    };
                    $this.trigger('lazyload', data);
                });
            }
            locateNextLazyLoadTrigger() {
                //:visible ne sert pas pour tester quand il est visible à l'écran via le scroll mais plutot pour
                //protéger le trigger quand cest un overlay qui apparait pour pas que ca continue a triggé celui ci dans la page derriere
                this.$currentLazyLoadTrigger = $('.accordion-content.is-expanded .lazy-loader-trigger:visible').first();
            }
        }
        Controls.LazyLoadHelper = LazyLoadHelper;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=lazyload-helper.pre.js.map
